import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex lg:items-center md:items-center items-start justify-between mb-1" }
const _hoisted_3 = { class: "font-bold lg:mr-0 md:mr-0 mr-2 break-all lg:w-auto md:w-auto w-auto flex-1 noresi" }
const _hoisted_4 = { class: "flex items-center lg:w-auto md:w-auto w-auto" }
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  class: "w-6 h-6",
  style: {"-ms-transform":"rotate(180deg)","-webkit-transform":"rotate(180deg)","transform":"rotate(180deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "#78909C",
    d: "M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23a1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z"
  })
], -1)
const _hoisted_6 = { class: "flex items-center justify-between mb-2" }
const _hoisted_7 = { class: "detail-route md:flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "mr-2 color-blue-grey-darken-1 font-bold lg:text-base md:text-base text-sm"
}
const _hoisted_9 = {
  key: 1,
  class: "grey-bg-border px-2 rounded-md lg:text-sm md:text-sm text-xs"
}
const _hoisted_10 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_11 = { class: "flex lg:items-center md:items-center items-start lg:w-auto md:w-auto w-full" }
const _hoisted_12 = { class: "lg:mr-4 md:mr-4 px-1 lg:w-auto md:w-auto w-1/4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-2 text-sm" }, "Kode Jadwal", -1)
const _hoisted_14 = { class: "color-blue-grey font-bold lg:text-base md:text-base text-sm truncate" }
const _hoisted_15 = { class: "lg:mr-4 md:mr-4 px-1 lg:w-auto md:w-auto w-2/4 sm:w-1/4" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-2 text-sm" }, "Tgl Keberangkatan", -1)
const _hoisted_17 = { class: "color-blue-grey font-bold lg:text-base md:text-base text-sm truncate" }
const _hoisted_18 = { class: "lg:mr-4 md:mr-4 px-1 lg:w-auto md:w-auto w-1/4" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-2 text-sm" }, "RIT", -1)
const _hoisted_20 = { class: "color-blue-grey font-bold lg:text-base md:text-base text-sm truncate" }
const _hoisted_21 = {
  key: 0,
  class: "lg:w-auto md:w-auto w-1/4"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "lg:flex md:flex hidden items-center" }, null, -1)
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = { class: "md:flex lg:items-center md:items-center items-start lg:w-auto md:w-auto w-full" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "lg:mr-4 md:mr-4 px-1 lg:w-auto md:w-auto w-1/4" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-2 text-sm" }, "Pengirim", -1)
const _hoisted_28 = { class: "color-blue-grey font-bold lg:text-base md:text-base text-sm truncate" }
const _hoisted_29 = { class: "lg:mr-4 md:mr-4 px-1 lg:w-auto md:w-auto w-1/4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-2 text-sm" }, "Penerima", -1)
const _hoisted_31 = { class: "color-blue-grey font-bold lg:text-base md:text-base text-sm truncate" }
const _hoisted_32 = { class: "lg:mr-4 md:mr-4 px-1 lg:w-auto md:w-auto w-1/4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-2 text-sm" }, "Jenis", -1)
const _hoisted_34 = { class: "color-blue-grey font-bold lg:text-base md:text-base text-sm truncate" }
const _hoisted_35 = {
  key: 0,
  class: "lg:w-auto md:w-auto md:w-1/4 mt-3 md:mt-0 px-1 md:px-0"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-2 text-sm" }, "Ketibaan", -1)
const _hoisted_38 = {
  key: 1,
  class: "color-green lg:text-base md:text-base text-sm"
}
const _hoisted_39 = { class: "lg:flex md:flex hidden items-center" }
const _hoisted_40 = { class: "font-bold color-blue-grey mr-2" }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, "Total Koli", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")

  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Card, {
          class: `card-no-shadow card-item-category ${(_ctx.item.StatusPengirimanId === 6) ? 'background-grey-lighten-5': ''}`
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("h5", _hoisted_3, "#" + _toDisplayString(_ctx.item.Resi), 1),
              _createVNode("div", _hoisted_4, [
                _createVNode("p", {
                  class: "rounded-md font-normal px-2 mr-1 lg:hidden md:hidden block lg:text-base md:text-base text-xs",
                  style: {background: `${_ctx.data.StatusPengiriman?.Attribute1 ?? '#eceff1'}`, border: `2px solid ${_ctx.data.StatusPengiriman?.Attribute2 ?? '#546e7a'}`, color: _ctx.data.StatusPengiriman?.Attribute2 ?? '#546e7a'}
                }, _toDisplayString(_ctx.item.StatusPengiriman.Status), 5),
                _hoisted_5
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                (_ctx.item.AgenAsal && _ctx.item.AgenTujuan)
                  ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.item.AgenAsal.Nama) + " - " + _toDisplayString(_ctx.item.AgenTujuan.Nama), 1))
                  : _createCommentVNode("", true),
                (_ctx.item.AgenTujuanId == _ctx.toAgentId)
                  ? (_openBlock(), _createBlock("span", _hoisted_9, "You"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("p", {
                class: "px-2 rounded-md font-normal text-base lg:inline-block md:inline-block hidden",
                style: {background: `${_ctx.data.StatusPengiriman?.Attribute1 ?? '#eceff1'}`, border: `2px solid ${_ctx.data.StatusPengiriman?.Attribute2 ?? '#546e7a'}`, color: _ctx.data.StatusPengiriman?.Attribute2 ?? '#546e7a'}
              }, _toDisplayString(_ctx.item.StatusPengiriman.Status), 5)
            ]),
            (_ctx.item.TransJadwalHd)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode("p", _hoisted_14, _toDisplayString(_ctx.item.TransJadwalHd?.KodeJadwal), 1)
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode("p", _hoisted_17, _toDisplayString(_ctx.moment(_ctx.item.TransJadwalHd.TanggalAktif).format('DD MMM YYYY')), 1)
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode("p", _hoisted_20, _toDisplayString(_ctx.item.TransJadwalHd.Rit), 1)
                    ]),
                    (_ctx.item.TransJadwalHd)
                      ? (_openBlock(), _createBlock("div", _hoisted_21))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_22
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode("p", _hoisted_28, _toDisplayString(_ctx.item.NamaPengirim), 1)
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("p", _hoisted_31, _toDisplayString(_ctx.item.NamaPenerima), 1)
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$deliveryTypeByCode(_ctx.item.TipePengiriman)), 1)
                  ])
                ]),
                (_ctx.item.TransJadwalHd)
                  ? (_openBlock(), _createBlock("div", _hoisted_35, [
                      (_ctx.item.TransJadwalHd.TransJadwalDetails.length === 1)
                        ? (_openBlock(), _createBlock("div", _hoisted_36, [
                            _hoisted_37,
                            (_ctx.item.StatusPengirimanId === 4)
                              ? (_openBlock(), _createBlock("p", {
                                  key: 0,
                                  class: _ctx.$isDateOnTime((_ctx.item.TransJadwalHd.TransJadwalDetails[0].WaktuKedatangan) ? _ctx.item.TransJadwalHd.TransJadwalDetails[0].WaktuKedatangan : _ctx.item.LastUpdate) ? 'color-primary font-bold lg:text-base md:text-base text-sm' : 'color-red font-bold lg:text-base md:text-base text-sm'
                                }, _toDisplayString(_ctx.$strDate((_ctx.item.TransJadwalHd.TransJadwalDetails[0].WaktuKedatangan) ? _ctx.item.TransJadwalHd.TransJadwalDetails[0].WaktuKedatangan : _ctx.item.LastUpdate)), 3))
                              : (_openBlock(), _createBlock("p", _hoisted_38, [
                                  _createVNode("b", null, _toDisplayString(_ctx.moment((_ctx.item.TransJadwalHd.TransJadwalDetails[0].WaktuKedatangan) ? _ctx.item.TransJadwalHd.TransJadwalDetails[0].WaktuKedatangan : _ctx.item.LastUpdate).format('DD MMM YYYY')), 1)
                                ]))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_39, [
                _createVNode("h5", _hoisted_40, _toDisplayString(_ctx.item['TransPengirimanDetails@odata.count']), 1),
                _hoisted_41
              ])
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]))
    : _createCommentVNode("", true)
}